import { withInstall } from '@jdesign-vue/utils'
import Upload from './src/upload.vue'
import UploadFallbackIcon from './src/components/fallback-icon.vue'

export const JdUpload = withInstall(Upload)
export const JdUploadFallbackIcon = withInstall(UploadFallbackIcon)
export default JdUpload

export * from './src/upload'
export * from './src/upload-content'
export * from './src/upload-list'
export * from './src/upload-dragger'
export * from './src/constants'
